import React from 'react';
import { useTranslation } from 'react-i18next';
import icon from '../assets/icons/Icon.svg'; // Adjust the path to your icon

function FAQ() {
  const { t } = useTranslation(); // Translation hook

  return (
    <div className="digital-twin-page">
      <h1 style={{ color: 'white' }}>{t('faq_section')}</h1>

      {/* FAQ Question 1 */}
      <div className="data-governance-card">
        <div className="data-governance-card-image">
          <img src={icon} alt="Icon" />
        </div>
        <div className="data-governance-card-content">
          <h3 className="data-governance-card-title">{t('faq_q1')}</h3>
          <p className="data-governance-card-description">{t('faq_r1')}</p>
        </div>
      </div>

      {/* FAQ Question 2 */}
      <div className="data-governance-card">
        <div className="data-governance-card-image">
          <img src={icon} alt="Icon" />
        </div>
        <div className="data-governance-card-content">
          <h3 className="data-governance-card-title">{t('faq_q2')}</h3>
          <p className="data-governance-card-description">{t('faq_r2_p1')}</p>
          <p className="data-governance-card-description">{t('faq_r2_p2')}</p>
        </div>
      </div>

      {/* FAQ Question 3 */}
      <div className="data-governance-card">
        <div className="data-governance-card-image">
          <img src={icon} alt="Icon" />
        </div>
        <div className="data-governance-card-content">
          <h3 className="data-governance-card-title">{t('faq_q3')}</h3>
          <ul>
            <li>{t('faq_r3_p1')}</li>
            <li>{t('faq_r3_p2')}</li>
            <li>{t('faq_r3_p3')}</li>
            <li>{t('faq_r3_p4')}</li>
            <li>{t('faq_r3_p5')}</li>
          </ul>
        </div>
      </div>

      {/* FAQ Question 4 */}
      <div className="data-governance-card">
        <div className="data-governance-card-image">
          <img src={icon} alt="Icon" />
        </div>
        <div className="data-governance-card-content">
          <h3 className="data-governance-card-title">{t('faq_q4')}</h3>
          <ul>
            <li>{t('faq_r4_p1')}</li>
            <li>{t('faq_r4_p2')}</li>
            <li>{t('faq_r4_p3')}</li>
            <li>{t('faq_r4_p4')}</li>
          </ul>
        </div>
      </div>

      {/* FAQ Question 5 */}
      <div className="data-governance-card">
        <div className="data-governance-card-image">
          <img src={icon} alt="Icon" />
        </div>
        <div className="data-governance-card-content">
          <h3 className="data-governance-card-title">{t('faq_q5')}</h3>
          <p className="data-governance-card-description">{t('faq_r5')}</p>
        </div>
      </div>

      {/* FAQ Question 6 */}
      <div className="data-governance-card">
        <div className="data-governance-card-image">
          <img src={icon} alt="Icon" />
        </div>
        <div className="data-governance-card-content">
          <h3 className="data-governance-card-title">{t('faq_q6')}</h3>
          <p className="data-governance-card-description">{t('faq_r6')}</p>
          <a href={t('Geospatial-Data-Request-url')} target="_blank" rel="noopener noreferrer">
            <button className="button">{t('data_request')}</button>
          </a>
        </div>
      </div>

      {/* FAQ Question 7 */}
      <div className="data-governance-card">
        <div className="data-governance-card-image">
          <img src={icon} alt="Icon" />
        </div>
        <div className="data-governance-card-content">
          <h3 className="data-governance-card-title">{t('faq_q7')}</h3>
          <p className="data-governance-card-description">{t('faq_r7')}</p>
        </div>
      </div>

      {/* FAQ Question 8 */}
      <div className="data-governance-card">
        <div className="data-governance-card-image">
          <img src={icon} alt="Icon" />
        </div>
        <div className="data-governance-card-content">
          <h3 className="data-governance-card-title">{t('faq_q8')}</h3>
          <p className="data-governance-card-description">{t('faq_r8_p1')}</p>
          <p className="data-governance-card-description">{t('faq_r8_p2')}</p>
        </div>
      </div>

      {/* FAQ Question 9 */}
      <div className="data-governance-card">
        <div className="data-governance-card-image">
          <img src={icon} alt="Icon" />
        </div>
        <div className="data-governance-card-content">
          <h3 className="data-governance-card-title">{t('faq_q9')}</h3>
          <ol>
            <li>{t('faq_r9_p1')}</li>
            <li>{t('faq_r9_p2')}</li>
            <li>{t('faq_r9_p3')}</li>
            <li>{t('faq_r9_p4')}</li>
            <li>{t('faq_r9_p5')}</li>
            <li>{t('faq_r9_p6')}</li>
            <li>{t('faq_r9_p7')}</li>
            <li>{t('faq_r9_p8')}</li>
            <li>{t('faq_r9_p9')}</li>
            <li>{t('faq_r9_p10')}</li>
            <li>{t('faq_r9_p11')}</li>
            <li>{t('faq_r9_p12')}</li>
            <li>{t('faq_r9_p13')}</li>
            <li>{t('faq_r9_p14')}</li>
            <li>{t('faq_r9_p15')}</li>
          </ol>
        </div>
      </div>

      {/* FAQ Question 10 */}
      <div className="data-governance-card">
        <div className="data-governance-card-image">
          <img src={icon} alt="Icon" />
        </div>
        <div className="data-governance-card-content">
          <h3 className="data-governance-card-title">{t('faq_q10')}</h3>
          <p className="data-governance-card-description">{t('faq_r10')}</p>
        </div>
      </div>
    </div>
  );
}

export default FAQ;
